import { api } from '@/lib/api';

/**
 * Télécharge un export (CSV) servi par l'API.
 *
 * Passe par le client HTTP plutôt que par un lien direct : le jeton d'accès
 * se renouvelle au besoin, et une erreur remonte à l'écran au lieu d'ouvrir
 * une page JSON. Le nom du fichier est celui que donne l'API.
 */
export async function telecharger(
  chemin: string,
  params: URLSearchParams | Record<string, unknown>,
  nomParDefaut: string,
): Promise<void> {
  const reponse = await api.get<Blob>(chemin, { params, responseType: 'blob' });
  const disposition = String(reponse.headers['content-disposition'] ?? '');
  const nom = /filename="([^"]+)"/.exec(disposition)?.[1] ?? nomParDefaut;
  const url = URL.createObjectURL(reponse.data);
  const lien = document.createElement('a');
  lien.href = url;
  lien.download = nom;
  document.body.appendChild(lien);
  lien.click();
  lien.remove();
  URL.revokeObjectURL(url);
}
